import { store } from "../../shared/store-redux";
import { authenticationExpired } from "../store-redux/modules/authenticated/actions";

export const userSetTokenLikeExpired = () => {
  store.dispatch(authenticationExpired('expired', false));
};